import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Label } from '../ui/label';

const MerchantSettingsTab = ({ profile }) => {
  return (
    <div className="space-y-6 mt-6">
      <Card>
        <CardHeader>
          <CardTitle className="font-heading">Business Information</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-muted-foreground">Business Name</Label>
              <p className="font-medium" data-testid="business-name-display">{profile.business_name}</p>
            </div>
            <div>
              <Label className="text-muted-foreground">Business Type</Label>
              <p className="font-medium capitalize" data-testid="business-type-display">{profile.business_type}</p>
            </div>
            <div>
              <Label className="text-muted-foreground">Website</Label>
              <p className="font-medium" data-testid="website-display">{profile.website || 'Not provided'}</p>
            </div>
            <div>
              <Label className="text-muted-foreground">Created</Label>
              <p className="font-medium" data-testid="created-date-display">{new Date(profile.created_at).toLocaleDateString()}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default MerchantSettingsTab;
